<template>
  <div  class="utlz-product-block utlz-reset" :class="{'tile-xs': inShoppingCartPage }">
    <transition-group name="fade" tag="div" :id="guid" class="list-items-wrapper utlz-row">
      <!-- BESPOKE TUIN: Changed blockSize to computed property -->
        <utlz-product-list-item
          v-for="product in products"
          :key="product.id"
          :product="product"
          :blockSize="blockSize"
          class="product-list-item">
        </utlz-product-list-item>
      </transition-group>
      <!-- BESPOKE: Added more info link -->
      <div v-if="config.MoreInfoUrl.length" class="more-info">
        <a class="more-items-url" :href="config.MoreInfoUrl">
          {{ config.MoreInfoDesc }}
        </a>
      </div>
      <!-- END BESPOKE TUIN -->
  </div>
</template>
<script>
import ProductListItem from 'src/components/webshop/products/product-list-item/ProductListItem.vue';
import { Product } from 'src/models/product.model';
import axios from 'axios';

export default {
  computed: {
    config () {
      return this.$root.$data.config;
    },
    productCodes () {
      return this.config.ProductCodes;
    },
    productInformationUrl () {
      const endpoint = window.vue.globalData.endpoints.productInformation;
      const client = this.config.ClientCode;
      const language = this.config.Language;

      return `${endpoint}/${client}?language=${language}`;
    },
    // BESPOKE
    blockSize() {
      if (this.inShoppingCartPage) {
        return 2;
      } else if (this.onHomePage) {
        return 12;
      }
      else {
        return this.config.blockSize;
      }
    },
    inShoppingCartPage () {
      return window.vue.modules.shoppingCartOverview !== undefined;
    },
    onHomePage() {
      // if no nav link is active yet, for the purpose of this block size we can assume its the homepage
      if ($(".header-v5 li.active").length == 0) {
        return this.config.FiveItemsPerRow;
      }
    }
    // END BESPOKE
  },
  components: {
    'utlz-product-list-item': ProductListItem
  },
  data () {
    return {
      products: [],
      // BESPOKE
      guid: Math.random().toString(36).substr(2, 9),
      setOwlCarousel: false
      // END BESPOKE
    }
  },
  methods: {
    getProductInformation () {
      axios.post(this.productInformationUrl, this.productCodes)
        .then(res => {
          const products = res.data.map(product => new Product(product));
          this.products = products;
          if (this.config.ShowStock) {
            this.getProductStock();
          } else {
            products.forEach(product => { product.setStock({ stockTotal: 0 }); })
          }

          if (this.config.ShowPrices) {
            this.getProductPrice()
          }

          if (this.config.ShowFavorites) {
            this.getCustomerLists();
          }
        });
    },
    getProductStock () {
      const url = window.vue.globalData.endpoints.productStockUrl
      this.products.forEach(productInitial => {
        axios.post(url, { 'productCode': productInitial.id })
          .then(res => {
            productInitial.setStock(res.data.d);
            // let index = this.products.findIndex(product => product.id === productWithStock.id);
            // state.products[index] = productWithStock;
          });
      });
    },
    getProductPrice () {
      let priceRequestWrapper = {};
      priceRequestWrapper.CustomerId = window.vue.globalData.userInformation.userLoggedOn ? window.vue.globalData.userInformation.customerId : '';
      priceRequestWrapper.Pricelist = window.vue.globalData.userInformation.customerPriceList;
      priceRequestWrapper.Products = this.products.map(prod => {
        let ret = {};
        ret.ProductId = prod.id;
        ret.ProductGroup = prod.discountGroup;

        ret.ProductUnit = '';
        if (prod.units !== undefined && prod.units !== null) {
          ret.ProductUnit = prod.units.length > 0 ? prod.units[0].code : '';
        }
        return ret;
      });

      let endpoint = window.vue.globalData.endpoints.productPriceUrl + 'prices/' + window.vue.globalData.userInformation.clientCode

      axios.post(endpoint, priceRequestWrapper)
        .then(res => {
          res.data.forEach(price => {
            let product = this.products[this.products.findIndex(x => x.id === price.productId)];
            product.setPrices(Object.keys(price.volumes).map(key => price.volumes[key]));
          });
        });
    },
    getCustomerLists () {
      const endpoint = `${window.vue.globalData.endpoints.customerList}/GetProductLists?debtorId=${window.vue.globalData.userInformation.customerId}`;
      axios.post(endpoint, this.products.map(prod => prod.id))
        .then(res => {
          Object.keys(res.data).forEach(prodCode => {
            let filteredProduct = this.products[this.products.findIndex(product => product.id === prodCode)];
            if (filteredProduct !== undefined) {
              filteredProduct.setCustomerLists(res.data[prodCode]);
            }
          });
        });
    }
  },
  // BESPOKE
  updated() {

    if (!this.inShoppingCartPage) {
      var listItems = $('#' + this.guid + ' .item');

      if (!this.setOwlCarousel && listItems.length > 0) {
        this.setOwlCarousel = true;
        
        var block = $('#' + this.guid);

        var owl = jQuery(block);
        owl.owlCarousel({
            items: 5, // Default number of items
            slideSpeed: 300,
            loop: true,
            autoPlay: false, // Disable autoplay
            rewindSpeed: 1000,
            pagination: false, // Disable dots
            navigation: true, // Enable navigation arrows
            navigationText: ["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"], // Customize the text for the navigation arrows
            responsive: true,
            responsiveRefreshRate: 200,
            responsiveBaseWidth: window,
            itemsDesktop: [1000, 5], // 5 items for desktops
            itemsTablet: [576, 3], // 3 items for tablets
            itemsMobile: [575, 1] // 1 item for mobile devices
        });
      }
    }
    
  },
  // END BESPOKE
  created () {
    this.getProductInformation();
  }
}
</script>
